(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    function justifyFirstParagraph() {
      document.querySelectorAll('rte-formatter[class*="product_desc"]').forEach(function (rte) {
        var p = Array.from(rte.querySelectorAll(':scope > p')).find(function (el) {
          return el.textContent.trim().length > 0;
        });
        if (p) p.style.textAlign = 'justify';
      });
    }
    document.addEventListener('DOMContentLoaded', justifyFirstParagraph);
    document.addEventListener('shopify:section:load', justifyFirstParagraph);
    justifyFirstParagraph();
  })();

  } catch(e) { console.error(e); }
})();
})();
